export {default} from 'netxcore@netx/core-auto-template/controller';

import AssetSizeSliderTemplate from './templates/asset-size-slider.html';
import CategoriesTemplate from './templates/categories.html';
import DragToUploadTemplate from './templates/drag-to-upload.html';
import FooterTemplate from './templates/footer.html';
import LoaderTemplate from './templates/loader.html';
import MobileNavTemplate from './templates/mobile-nav.html';
import PseudoProgressTemplate from './templates/pseudo-progress.html';

const ThemeTemplates = {
	'asset-size-slider': AssetSizeSliderTemplate,
	categories: CategoriesTemplate,
	'drag-to-upload': DragToUploadTemplate,
	footer: FooterTemplate,
	loader: LoaderTemplate,
	'mobile-nav': MobileNavTemplate,
	'pseudo-progress': PseudoProgressTemplate,
};

/**
 * @event module:autoTemplate#autoTemplate:extend
 */
dispatcher.once('autoTemplate:extend', function (NS) {
	NS.templates = _.extend(NS.templates || {}, ThemeTemplates);
});
